import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import HotTours from '../components/HotTours';
import MinPrices from '../components/MinPrices';
import FAQ from '../components/FAQ';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import SEO from '../components/SEO';

const Home = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "TravelAgency",
    "name": "Максимум Тур",
    "image": `${window.location.origin}/logo512.png`,
    "telephone": "+79964269652",
    "url": window.location.origin,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Алеутская улица, 45а",
      "addressLocality": "Владивосток",
      "addressCountry": "RU"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "150"
    }
  };

  useEffect(() => {
    // Load Tourvisor scripts
    const loadTourvisorScripts = () => {
      if (!document.querySelector('script[src="https://tourvisor.ru/module/init.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://tourvisor.ru/module/init.js';
        script.async = true;
        document.body.appendChild(script);
      }
    };
    
    loadTourvisorScripts();
  }, []);

  return (
    <div className="home">
      <SEO 
        title="Максимум Тур - Туры во Владивостоке | Горящие туры, Путевки по всему миру"
        description="Турагентство Максимум Тур во Владивостоке предлагает горящие туры, минимальные цены на путевки по всему миру. Подбор туров онлайн, консультации экспертов. Китай, Таиланд, Вьетнам и другие направления."
        keywords="туры Владивосток, горящие туры, купить тур, турагентство, путевки, отдых, путешествия, Китай, Таиланд, Вьетнам, турфирма, туроператор"
        type="website"
        structuredData={structuredData}
      />
      <Menu />
      <Header />
      <Hero />
      <HotTours />
      <MinPrices />
      <FAQ />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Home;